export default __webpack_public_path__ + "static/media/BulletproofBody.e5527d51.png";